import request from '@/utils/request'

const baseUrl = '/chamber-service/v1/checkout-inspection'

export function getCheckoutInspectionByBookingApi(subBookingGroupId) {
  return request({
    url: `${baseUrl}/requests/by-sub-booking-group/${subBookingGroupId}`,
    method: 'get'
  })
}

export function createCheckoutInspectionApi(subBookingGroupId) {
  return request({
    url: `${baseUrl}/requests`,
    method: 'post',
    data: { sub_booking_group_id: subBookingGroupId }
  })
}

export function cancelCheckoutInspectionApi(requestId) {
  return request({
    url: `${baseUrl}/requests/${requestId}`,
    method: 'delete'
  })
}
